import classNames, { Argument } from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { usePriceFormatter } from 'utils/PriceFormatter/usePriceFormatter';

type PreAuthorizedAmountLineProps = {
  amount?: number,
  className?: Argument
};

const PreAuthorizedAmountLine: React.FC<PreAuthorizedAmountLineProps> = ({ amount, className }) => {
  const priceFormatter = usePriceFormatter();

  return (
    <div className={classNames(className)}>
      <FormattedMessage id="preAuthorizedAmounts.label" defaultMessage="Customer share" tagName="span" />

      {amount === 0 && (<FormattedMessage id="preAuthorizedAmounts.freeOfCharge" defaultMessage="Free of charge" tagName="span" />)}
      {amount && amount > 0 && (
        <span>{priceFormatter(amount)}</span>
      )}
    </div>
  );
};

export default PreAuthorizedAmountLine;
